import { Injectable, signal, WritableSignal } from '@angular/core';
import { Params } from '@angular/router';
import { ContentType } from '../pages/content-creation/content-creation';

type ListQueryParamsByContentType = Partial<Record<ContentType, Params>>;

@Injectable({
  providedIn: 'root',
})
export class PaginatorService {
  private readonly listQueryParams: WritableSignal<ListQueryParamsByContentType> =
    signal<ListQueryParamsByContentType>({});

  setListQueryParams(contentType: ContentType, params: Params): void {
    this.listQueryParams.update((current: ListQueryParamsByContentType) => ({
      ...current,
      [contentType]: params,
    }));
  }

  getListQueryParams(contentType: ContentType | undefined): Params {
    if (!contentType) return {};
    return this.listQueryParams()[contentType] ?? {};
  }
}
